import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import MobileFooterNav from './components/MobileFooterNav';
import SubscriptionCTA from './components/SubscriptionCTA';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import HomePage from './pages/HomePage';
import SermonsPage from './pages/SermonsPage';
import BibleStudiesPage from './pages/BibleStudiesPage';
import PrayerPage from './pages/PrayerPage';
import BlogPage from './pages/BlogPage';
import OutreachPage from './pages/OutreachPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import StatementOfFaithPage from './pages/StatementOfFaithPage';
import SubscribePage from './pages/SubscribePage';
import SubscribeThankYouPage from './pages/SubscribeThankYouPage';
import AdminPage from './pages/AdminPage';
import BlogPostPage from './pages/BlogPostPage';
import WhyWeDoPage from './pages/WhyWeDoPage';
import VisitPage from './pages/VisitPage';
import DBUPage from './pages/DBUPage';
import DevotionPage from './pages/DevotionPage';
import LibraryPage from './pages/LibraryPage';
import BookReaderPage from './pages/BookReaderPage';
import GivePage from './pages/GivePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import SongsPage from './pages/SongsPage';
import SongDetailPage from './pages/SongDetailPage';
import PlaylistsPage from './pages/PlaylistsPage';
import PlaylistEditPage from './pages/PlaylistEditPage';
import PlaylistViewPage from './pages/PlaylistViewPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <main className="min-h-screen pb-20 lg:pb-0">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/visit" element={<VisitPage />} />
              <Route path="/dbu" element={<DBUPage />} />
              <Route path="/sermons" element={<SermonsPage />} />
              <Route path="/bible-studies" element={<BibleStudiesPage />} />
              <Route path="/prayer" element={<PrayerPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/outreach" element={<OutreachPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/why-we-do" element={<WhyWeDoPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/statement-of-faith" element={<StatementOfFaithPage />} />
              <Route path="/subscribe" element={<SubscribePage />} />
              <Route path="/subscribe/thank-you" element={<SubscribeThankYouPage />} />
              <Route path="/devotions" element={<DevotionPage />} />
              <Route path="/devotions/:month/:day" element={<DevotionPage />} />
              <Route path="/library" element={<LibraryPage />} />
              <Route path="/library/:id" element={<BookReaderPage />} />
              <Route path="/give" element={<GivePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/songs/:language" element={<SongsPage />} />
              <Route path="/songs/:language/:songId" element={<SongDetailPage />} />
              <Route path="/playlists" element={<PlaylistsPage />} />
              <Route path="/playlists/:playlistId" element={<PlaylistViewPage />} />
              <Route path="/playlists/:playlistId/edit" element={<PlaylistEditPage />} />
              <Route path="/admin" element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              } />
            </Routes>
          </main>
          <Footer />
          <ScrollToTop />
          <MobileFooterNav />
          <SubscriptionCTA />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;